import { Ce } from './Ce';

class TrainingPlanTemplate extends Ce {
    constructor() {
        super();
        this.baseUrl += '/trainingPlanTemplate';
    }

    data({ certCatId, certExamType, templateName, isAvailable, currentPage, pageSize } = {}) {
        return super.get('/data', {
            certCatId,
            certExamType,
            templateName,
            isAvailable,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({
        id,
        certExamId,
        templateName,
        teachingMaterials,
        isAvailable,
        remarks,
        theoryTrainingJson,
        practicalTrainingJson,
    } = {}) {
        return super.post('/save', {
            id,
            certExamId,
            templateName,
            teachingMaterials,
            isAvailable,
            remarks,
            theoryTrainingJson,
            practicalTrainingJson,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    status({ id, isAvailable } = {}) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }
}

export default new TrainingPlanTemplate();
export { TrainingPlanTemplate };
